export const AJNA_POSITION_ABI = [
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "operator",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "setOperator",
    inputs: [{ name: "op", type: "address" }],
    outputs: [],
    stateMutability: "nonpayable",
  },
] as const;
